/**
 * @generated SignedSource<<d09a01bc2c54ad980c04f21a4bc08ab1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskDifferenceCounterLabel_difference$data = {
  readonly assignedTo?: {
    readonly __typename: "Diff";
  } | null;
  readonly creationType?: {
    readonly __typename: "Diff";
  } | null;
  readonly description?: {
    readonly __typename: "Diff";
  } | null;
  readonly originalTask?: {
    readonly __typename: "Diff";
  } | null;
  readonly status?: {
    readonly __typename: "Diff";
  } | null;
  readonly title?: {
    readonly __typename: "Diff";
  } | null;
  readonly " $fragmentType": "TaskDifferenceCounterLabel_difference";
};
export type TaskDifferenceCounterLabel_difference$key = {
  readonly " $data"?: TaskDifferenceCounterLabel_difference$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskDifferenceCounterLabel_difference">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskDifferenceCounterLabel_difference",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Diff",
          "kind": "LinkedField",
          "name": "title",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Diff",
          "kind": "LinkedField",
          "name": "description",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Diff",
          "kind": "LinkedField",
          "name": "status",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Diff",
          "kind": "LinkedField",
          "name": "originalTask",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Diff",
          "kind": "LinkedField",
          "name": "creationType",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Diff",
          "kind": "LinkedField",
          "name": "assignedTo",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "type": "TaskDifference",
      "abstractKey": null
    }
  ],
  "type": "Difference",
  "abstractKey": "__isDifference"
};
})();

(node as any).hash = "02625b5503bc38192945397e77d749ea";

export default node;
